const STAT_GROUPS = ["hitting", "pitching", "fielding"];

const hasSeasonRows = (seasons) =>
  Boolean(seasons && Object.keys(seasons).length > 0);

const hasCareerValues = (career = {}) =>
  Object.entries(career).some(
    ([key, value]) =>
      !key.startsWith("_") && value != null && String(value).trim() !== ""
  );

export const groupHasDisplayableStats = (group = {}) =>
  hasSeasonRows(group.seasons) || hasCareerValues(group.career);

export const playerHasDisplayableStats = (stats = {}) =>
  STAT_GROUPS.some((group) => groupHasDisplayableStats(stats[group]));

export const defaultStatCategory = (stats = {}) => {
  if (groupHasDisplayableStats(stats.hitting)) return "hitting";
  if (groupHasDisplayableStats(stats.pitching)) return "pitching";
  if (groupHasDisplayableStats(stats.fielding)) return "fielding";
  return "hitting";
};

export const playerStatsEmptyMessage = ({ isMlbStub = false } = {}) =>
  isMlbStub
    ? "We have this player from MLB but don’t have career tables yet."
    : "No career or season tables are available for this player yet.";

export const isMlbStubPlayerId = (playerId) =>
  /^mlb\d+$/i.test(String(playerId ?? "").trim());
